import handler from 'api/handler'

const prefix = '/admin/newsFeedSettings'

const methods = {
  get: args => handler({ method: 'get', url: prefix + '/get', args }),
  update: args => handler({ method: 'post', url: prefix + '/update', args }),
  triggerFetch: args => handler({ method: 'post', url: prefix + '/triggerFetch', args }),
  getStats: args => handler({ method: 'get', url: prefix + '/stats', args })
}

export default methods

